(function () {
  'use strict';

  var config = {
    demoPageUrl: '/pages/at-home-demo',
    noResultsContainer: '.storerocket-no-results',
    noResultsContent: '.storerocket-no-results-content',
    showAllButton: '.storerocket-show-all-results-link'
  };

  var injected = false;

  function reset() {
    injected = false;
    var existing = document.querySelector('.byrna-no-results-message');
    if (existing) existing.parentNode.removeChild(existing);
  }

  function inject() {
    if (injected) return;

    var container = document.querySelector(config.noResultsContainer);
    if (!container || !container.classList.contains('is-visible')) return;

    var content = container.querySelector(config.noResultsContent);
    if (!content) return;

    var message = document.createElement('div');
    message.className = 'byrna-no-results-message';
    message.innerHTML =
      '<p class="byrna-no-results-body">' +
        'We don&rsquo;t have any physical locations in your area at this time but if you would ' +
        'like to demo a Byrna Product at your home you can go ' +
        '<a href="' + config.demoPageUrl + '" class="byrna-no-results-link">HERE</a> ' +
        'to participate in our At Home Demo Program.' +
      '</p>';

    var button = content.querySelector(config.showAllButton);
    if (button) {
      content.insertBefore(message, button);
    } else {
      content.appendChild(message);
    }

    injected = true;
  }

  function onMutation() {
    var container = document.querySelector(config.noResultsContainer);
    var visible = container && container.classList.contains('is-visible');
    if (visible) {
      inject();
    } else {
      reset();
    }
  }

  function init() {
    // Observe #storerocket-widget — it's in our Liquid template and never replaced.
    // #storerocket-panel gets torn down and recreated on each search, orphaning any
    // observer attached to it. The widget is a stable ancestor.
    var widget = document.querySelector('#storerocket-widget');
    if (!widget) return;

    inject();

    new MutationObserver(onMutation).observe(widget, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
